
import { defineComponent, computed, PropType } from 'vue'
import Tag from '@/components/elements/Tag.vue'
import Button from '@/components/elements/Button.vue'
export default defineComponent({
  name: 'EventCard',
  components: {
    Tag,
    Button
  },
  props: {
    title: {
      type: String,
      required: true
    },
    thumbnail: {
      type: String,
      default: require('@/assets/images/common/noimg.jpg') as string
    },
    eventTypes: Array as PropType<string[]>,
    date: {
      type: String,
      default: ''
    },
    place: {
      type: String,
      default: ''
    },
    tags: Array,
    description: {
      type: String,
      default: ''
    },
    link: String,
    category: {
      type: String,
      default: ''
    },
    buttonLabel: {
      type: String,
      default: '詳細・予約'
    },
    rectangle: Boolean,
    isFinished: {
      type: Boolean,
      default: false
    },
    isArchived: {
      type: Boolean,
      default: false
    },
    isCancelable: {
      type: Boolean,
      default: false
    },
    clickCancel: Function
  },
  setup(props) {
    const isOnline = computed(() => props.eventTypes?.includes('オンライン'))
    const isOffline = computed(() => props.eventTypes?.includes('オフライン'))
    const isCareer = computed(() =>
      props.eventTypes?.includes('キャリアガイダンス')
    )

    const categoryIcon = computed(() => {
      if (isCareer.value) return require('@/assets/images/icon/book-white.svg')
      if (isOnline.value) return require('@/assets/images/icon/pc-white.svg')
      if (isOffline.value)
        return require('@/assets/images/icon/hospital-02-white.svg')
    })
    const eventTypeClass = computed(() => {
      if (isCareer.value) return 'isCareer'
      if (isOnline.value) return 'isOnline'
      if (isOffline.value) return 'isOffline'
    })
    const getEventLabelClass = (eventType: string): string | undefined => {
      if (eventType === 'キャリアガイダンス') return 'isCareer'
      if (eventType === 'オンライン') return 'isOnline'
      if (eventType === 'オフライン') return 'isOffline'
    }

    return {
      categoryIcon,
      eventTypeClass,
      getEventLabelClass
    }
  }
})
